import * as React from 'react';
import Avatar from './';

const colors = [
  '#F44336',
  '#FF4081',
  '#9C27B0',
  '#673AB7',
  '#3F51B5',
  '#2196F3',
  '#03A9F4',
  '#00BCD4',
  '#009688',
  '#4CAF50',
  '#8BC34A',
  '#CDDC39',
  '#FFEB3B',
  '#FFC107',
  '#FF9800',
  '#FF5722',
  '#795548',
  '#9E9E9E',
  '#607D8B'
];

// Helpers
function randomColor(seed: number, colorsArray: Array<string>): string {
  return colorsArray[seed % colors.length];
}

function textToNumber(value: string): number {
  const letters = [];
  for (let i = 0; i < value.length; i++) {
    letters.push(value.charCodeAt(i));
  }
  return letters.reduce((a, b) => a + b, 0);
}

// Component
export interface IProps {
  text: string;
  src?: string | null;
  size?: number;
  rounded?: boolean;
  className?: string;
  style?: React.CSSProperties;
}

function FancyAvatar({
  src,
  text,
  size = 40,
  rounded = true,
  className,
  style
}: IProps) {
  if (src) {
    return (
      <Avatar
        className={className}
        src={src}
        style={{
          ...style,
          height: size,
          width: size,
          borderRadius: rounded ? '50%' : 2,
          fontSize: size / 2
        }}
      />
    );
  }
  const initial = text.split(' ').map(item => item.charAt(0));
  return (
    <Avatar
      className={className}
      style={{
        ...style,
        background: randomColor(textToNumber(text), colors),
        height: size,
        width: size,
        borderRadius: rounded ? '50%' : 2,
        fontSize: size / 2
      }}
    >
      {initial[0] + (initial.length > 1 ? initial[initial.length - 1] : '')}
    </Avatar>
  );
}

export default FancyAvatar;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Avatar/FancyAvatar.tsx